import { MessageCircle } from "lucide-react";
import { CONTACT } from "@/lib/constants";
export default function WhatsAppFab() {
  return (
    <a href={`${CONTACT.whatsappHref}?text=${encodeURIComponent("Hi House of Projects, I'd like to discuss my business.")}`} target="_blank" rel="noopener noreferrer"
      aria-label="Chat on WhatsApp" className="hp-fab fixed right-4 sm:right-5 z-40 inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] text-white font-bold w-14 h-14 sm:w-auto sm:h-auto sm:px-5 sm:py-3 shadow-lg hover:brightness-95">
      <MessageCircle className="w-6 h-6 sm:w-5 sm:h-5" aria-hidden="true" /> <span className="hidden sm:inline">WhatsApp</span>
    </a>
  );
}
